<template>
  <div>
    <vs-button :warn="shipment !== undefined" @click="showDialog = true">{{ shipment ? 'Update' : 'Create' }} Shipment</vs-button>

    <vs-dialog v-model="showDialog">
      <template #header>
        <h1 class="dialog-title">{{ item.name }} <b>Shipment</b></h1>
      </template>

      <form @submit.prevent="shipmentHandler">
        <vs-input type="number" min="1" :max="max" placeholder="QTY" v-model="qty" required>
          <template #icon>#</template>
        </vs-input>

        <vs-input type="date" v-model="shipDate" required>
          <template #icon><i class="bx bx-calendar" /></template>
        </vs-input>

        <vs-input placeholder="Tracking" v-model="tracking">
          <template #icon><i class="bx bx-package" /></template>
        </vs-input>

        <vs-select placeholder="Ship Method" v-model="shipMethod">
          <vs-option label="Ocean" value="Ocean">Ocean</vs-option>
          <vs-option label="Air" value="Air">Air</vs-option>
          <vs-option label="Other" value="Other">Other</vs-option>
        </vs-select>

        <vs-button block :loading="loading">{{ shipment ? 'Update' : 'Create' }} Shipment</vs-button>
        <vs-button v-if="shipment" type="button" block danger @click="deleteShipment">Delete Shipment</vs-button>
      </form>
    </vs-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import supabase from '../supabase';

export default {
  name: 'WShipment',

  props: {
    item: Object,
    shipment: Object,
  },

  data() {
    return {
      qty: '',
      tracking: '',
      shipMethod: '',
      loading: false,
      showDialog: false,
      shipDate: moment().format('YYYY-MM-DD'),
      max: this.shipment !== undefined ? this.item.available : (this.item.available || this.item.qty),
    };
  },

  computed: {
    orderID() {
      return this.$route.params.orderID;
    },
  },

  created() {
    if (this.shipment) {
      this.qty = this.shipment.qty || '';
      this.tracking = this.shipment.tracking || '';
      this.shipMethod = this.shipment.ship_method || '';
      this.shipDate = this.shipment.ship_date ? moment(this.shipment.ship_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    }
  },

  methods: {
    async shipmentHandler() {
      try {
        this.loading = true;

        if (!this.shipment) {
          await supabase
            .from('shipments')
            .insert([
              {
                qty: this.qty,
                ship_date: moment(this.shipDate),
                tracking: this.tracking !== '' ? this.tracking : null,
                ship_method: this.shipMethod !== '' ? this.shipMethod : null,
                order_id: this.orderID,
                item_id: this.item.itemID,
              },
            ]);
        } else {
          await supabase
            .from('shipments')
            .update({
              qty: this.qty,
              ship_date: moment(this.shipDate),
              tracking: this.tracking !== '' ? this.tracking : null,
              ship_method: this.shipMethod !== '' ? this.shipMethod : null,
              order_id: this.orderID,
              item_id: this.item.itemID,
            })
            .match({ id: this.shipment.id });
        }

        this.$router.go();
      } catch (error) {
        this.loading = false;
        alert(error.message);
      }
    },

    async deleteShipment() {
      try {
        await supabase
          .from('shipments')
          .match({ id: this.shipment.id })
          .delete();

        this.$router.go();
      } catch (error) {
        this.loading = false;
        alert(error.message);
      }
    },
  },
};
</script>
